
import { Component, Vue, Watch, Prop, Emit } from "vue-property-decorator"
import { namespace, Getter, Action, State } from "vuex-class"

import vSelect from "vue-select"

import { CaseDetails, CaseUser, CaseField, Team } from "@/types"

import api from "@/services/api"

	@Component({
		components: {
			"v-select": vSelect
		}
	})
export default class UserSearch extends Vue {
	@Prop()
	public currentCase: any;

	@Prop({ default: true })
	searchTeams!: boolean;

	@Prop({ default: false })
	isExternalUser!: boolean;

	@Prop({ default: false })
	showTeamFilter!: boolean;

	@Prop({ default: () => [] })
	existingUserIds!: string[];

	@Prop({ default: () => [] })
	allowedTeamsIds!: string[];

	@Prop({ default: true })
	disallowAdded!: boolean

	@State public teams!: Team[];

	private inviteSearch: string = "";
	private inviteUsers: any[] = [];
	private selectedItem: any = null;
	private externalUser: any = {
		isExternal: true,
		name: null,
		email: null,
		id: null
	};
	private teamFilter: string | null = null;

	get filterTeams (): Team[] {
		if (!this.allowedTeamsIds || this.allowedTeamsIds.length === 0) return this.teams
		return this.teams.filter(t => this.allowedTeamsIds.indexOf(t.id) > -1)
	}

	get enableTeamFilter () {
		return this.showTeamFilter && this.filterTeams.length > 1
	}

	public async fetchOptions (search: string, loading: (isLoading: boolean) => void) {
		if (search === "") {
			this.inviteUsers = []
		} else {
			loading(true)

			try {
				this.inviteUsers = (this.currentCase
					? await api.searchInvite(this.currentCase.id, search,
						this.teamFilter
							? [this.teamFilter]
							: this.allowedTeamsIds && this.allowedTeamsIds.length > 0 ? this.allowedTeamsIds : null,
						this.searchTeams,
						this.disallowAdded)
					: await api.searchUsers(search, this.teamFilter, this.allowedTeamsIds && this.allowedTeamsIds.length > 0 ? this.allowedTeamsIds : null))
					.filter((user: any) => this.existingUserIds.indexOf(user.id) === -1)
			} finally {
				loading(false)
			}
		}
	}

	public userPicture (inviteSearchResult: any): string {
		if (inviteSearchResult.isTeam) {
			return ""
		} else if (inviteSearchResult.imageUrl) {
			return inviteSearchResult.imageUrl!
		} else if (inviteSearchResult.pictureUrl) {
			return inviteSearchResult.pictureUrl!
		} else {
			return api.pictureUrl(inviteSearchResult.id)
		}
	}

	@Emit("selected")
	public async addUser (inviteSearchResult: any) {
		if (inviteSearchResult.isExternal) {
			inviteSearchResult.id = await api.generateID()
		}
		return inviteSearchResult
	}

	public loadedImage (result: any) {
		// do nothing here - this is just a handler to tell the browser not to show it until it's loaded
	}
}
